import { Box, HStack, Icon, Stack, Text } from '@chakra-ui/react';
import { FaStar } from 'react-icons/fa';
import { NestedArea } from '@habity/types';
import { ListSkeleton } from '../../../homes/list/components/ListSkeleton';

interface AreaCardDataProps {
  area: NestedArea;
  isLoading?: boolean;
  variant?: 'default' | 'compact';
}

export const AreaCardData = ({
  area,
  isLoading = false,
  variant = 'default',
}: AreaCardDataProps) => {
  const { name, municipality, for_sale_homes_count = 0, rating, rating_count } = area || {};

  return (
    <Stack
      spacing="1"
      pt={0}
      pb={1}
      cursor="pointer"
      justifyContent="flex-start"
    >
      {/* Area Name */}
      <ListSkeleton isLoaded={!isLoading}>
        <Box mt="1" noOfLines={1}>
          <HStack spacing="1" justifyContent="flex-start">
            <Text
              size="md"
              fontWeight="semibold"
              flexShrink="0"
              color="blackAlpha.900"
              lineHeight={1.5}
              noOfLines={1}
              _groupHover={{ textDecoration: "underline" }}
            >
              {name}
            </Text>
          </HStack>
        </Box>
      </ListSkeleton>

      {/* Rating - only show if area has rating */}
      {rating && rating_count && (
        <HStack spacing="1" justifyContent="flex-start">
          <ListSkeleton isLoaded={!isLoading}>
            <HStack spacing="1" alignItems="center">
              <Icon as={FaStar} color="yellow.500" boxSize="3" />
              <Text
                color="blackAlpha.800"
                fontSize="sm"
                fontWeight="medium"
                lineHeight={1.2}
              >
                {Number(rating).toFixed(1)}
              </Text>
              <Text
                color="blackAlpha.600"
                fontSize="sm"
                lineHeight={1.2}
              >
                ({rating_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')})
              </Text>
            </HStack>
          </ListSkeleton>
        </HStack>
      )}

      {/* Municipality */}
      {municipality && (
        <HStack justifyContent="flex-start">
          <ListSkeleton isLoaded={!isLoading}>
            <Text
              color="blackAlpha.700"
              size="sm"
              lineHeight={1.2}
              noOfLines={1}
              fontWeight="normal"
            >
              {municipality.name}
            </Text>
          </ListSkeleton>
        </HStack>
      )}

      {/* Homes count */}
      <HStack alignItems="baseline" justifyContent="flex-start">
        <ListSkeleton isLoaded={!isLoading}>
          <Text
            color="blackAlpha.600"
            fontSize={variant === 'compact' ? 'xs' : 'sm'}
            noOfLines={1}
            fontWeight="normal"
          >
            {for_sale_homes_count} {for_sale_homes_count === 1 ? 'bostad' : 'bostäder'}
          </Text>
        </ListSkeleton>
      </HStack>
    </Stack>
  );
};
